import Image1 from '@/assets/gallery/image1.webp'
import Image2 from '@/assets/gallery/image2.webp'
import Image3 from '@/assets/gallery/image3.webp'
import Image4 from '@/assets/gallery/image4.webp'
import Image5 from '@/assets/gallery/image5.webp'
import Image6 from '@/assets/gallery/image6.webp'
import Image7 from '@/assets/gallery/image7.webp'
import Image8 from '@/assets/gallery/image8.webp'
import Image9 from '@/assets/gallery/image9.webp'
import Image10 from '@/assets/gallery/image10.webp'
import Image11 from '@/assets/gallery/image11.webp'
import Image12 from '@/assets/gallery/image12.webp'
import Image13 from '@/assets/gallery/image13.webp'
import Image14 from '@/assets/gallery/image14.webp'
import Image15 from '@/assets/gallery/image15.webp'
import Image16 from '@/assets/gallery/image16.webp'
import Image17 from '@/assets/gallery/image17.webp'
import Image18 from '@/assets/gallery/image18.webp'
import Image19 from '@/assets/gallery/image19.webp'
import Image20 from '@/assets/gallery/image20.webp'
import Image21 from '@/assets/gallery/image21.webp'
import Image22 from '@/assets/gallery/image22.webp'
import Image23 from '@/assets/gallery/image23.webp'
import Image24 from '@/assets/gallery/image24.webp'
import Image25 from '@/assets/gallery/image25.webp'
import Image26 from '@/assets/gallery/image26.webp'
import Image27 from '@/assets/gallery/image27.webp'
import Image28 from '@/assets/gallery/image28.webp'
import Image29 from '@/assets/gallery/image29.webp'
import Image30 from '@/assets/gallery/image30.webp'
import Image31 from '@/assets/gallery/image31.webp'
import Image32 from '@/assets/gallery/image32.webp'

export const albumOneImages = (translations) => {
  return [
    { src: Image1, alt: translations('alt.image1') },
    { src: Image2, alt: translations('alt.image2') },
    { src: Image3, alt: translations('alt.image3') },
    { src: Image4, alt: translations('alt.image4') },
    { src: Image5, alt: translations('alt.image5') },
    { src: Image6, alt: translations('alt.image6') },
    { src: Image7, alt: translations('alt.image7') },
    { src: Image8, alt: translations('alt.image8') },
    { src: Image9, alt: translations('alt.image9') },
    { src: Image10, alt: translations('alt.image10') },
    { src: Image11, alt: translations('alt.image11') },
    { src: Image12, alt: translations('alt.image12') },
    { src: Image13, alt: translations('alt.image13') },
    { src: Image14, alt: translations('alt.image14') },
    { src: Image15, alt: translations('alt.image15') },
    { src: Image16, alt: translations('alt.image16') },
    { src: Image17, alt: translations('alt.image17') },
    { src: Image18, alt: translations('alt.image18') },
    { src: Image19, alt: translations('alt.image19') },
    { src: Image20, alt: translations('alt.image20') },
    { src: Image21, alt: translations('alt.image21') },
    { src: Image22, alt: translations('alt.image22') },
    { src: Image23, alt: translations('alt.image23') },
    { src: Image24, alt: translations('alt.image24') },
    { src: Image25, alt: translations('alt.image25') },
    { src: Image26, alt: translations('alt.image26') },
    { src: Image27, alt: translations('alt.image27') },
    { src: Image28, alt: translations('alt.image28') },
    { src: Image29, alt: translations('alt.image29') },
    { src: Image30, alt: translations('alt.image30') },
    { src: Image31, alt: translations('alt.image31') },
    { src: Image32, alt: translations('alt.image32') }
  ]
}

